import "./Tickets.css";

import { useState } from "react";
import { BiComment } from "react-icons/bi";

import {
  type MessageType,
  type TicketType,
} from "../../_lib/_store/interfaces/tickets";
import { TicketsMain } from "./components/TicketsMain";
import { TicketsSidebar } from "./components/TicketsSidebar";

export const Tickets = () => {
  const [selectedTicket, setSelectedTicket] = useState<TicketType | null>(null);
  const handleAddTicket = (ticket: TicketType) => {
    // Ye messagesByTicket me initial message add karega
    setMessagesByTicket((prev) => ({
      ...prev,
      [ticket.id]: ticket.messages,
    }));
    // Aur us ticket ko select kare taake chat turant open ho
    setSelectedTicket(ticket);
  };

  const [messagesByTicket, setMessagesByTicket] = useState<{
    [key: number]: MessageType[];
  }>({});

  const handleSendMessage = (ticketId: number, newMessage: MessageType) => {
    setMessagesByTicket((prev) => ({
      ...prev,
      [ticketId]: [...(prev[ticketId] || []), newMessage],
    }));
  };

  return (
    <div className="mainticket">
      <h1 className="mainticket-title">
        <span className="mainticket-icon">
          <BiComment />
        </span>
        Help & Support Tickets
      </h1>
      <p className="mainticket-subtitle">
        Manage customer support tickets and provide assistance
      </p>

      <div className="tickets-container">
        <TicketsSidebar
          onSelect={setSelectedTicket}
          selected={selectedTicket}
          onAddTicket={handleAddTicket}
        />
        <TicketsMain
          ticket={selectedTicket}
          messages={
            selectedTicket ? messagesByTicket[selectedTicket.id] || [] : []
          }
          onSendMessage={handleSendMessage}
        />
      </div>
    </div>
  );
};
